module.exports = __webpack_public_path__ + "static/media/clean-sweep.0c92087a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/clean-sweep.jpg
// module id = 285
// module chunks = 0